import React, { useEffect, useCallback, useState } from 'react';
import PageBackground from '../../components/Layouts/PageBackground.jsx';
import './DownloadInformation.css';
import InformationBox from '../../components/InformationBox.jsx';
import { downloadInformations } from '../../data.js';
import { useNavigate } from 'react-router-dom';
import { useTrack } from '../../hooks/contexts.hook.tsx';
import { getPlatformName } from '../../utils/platform.js';

const DOWNLOAD_INFORMATION = {
    windows: {
        name: 'WINDOWS',
        url: process.env.REACT_APP_WINDOWS_DOWNLOAD_URL,
    },
    mac: {
        name: 'MAC',
        url: process.env.REACT_APP_MACOS_DOWNLOAD_URL,
    },
    desktop: {
        name: 'DESKTOP',
        url: process.env.REACT_APP_WINDOWS_DOWNLOAD_URL,
    },
    ios: {
        name: 'IOS',
        url: process.env.REACT_APP_IOS_STORE_URL,
    },
    android: {
        name: 'ANDROID',
        url: process.env.REACT_APP_ANDROID_STORE_URL,
    }
};

const DownloadInformation = () => {
    const navigate = useNavigate();
    const isMobile = window.innerWidth <= 885;

    useEffect(() => {
        if (isMobile) navigate('/');
    }, [isMobile, navigate]);

    const platformName = getPlatformName();

    const { trackAppDownload } = useTrack();
    const [downloadError, setDownloadError] = useState(false);
    const [activePlatform, setActivePlatform] = useState(platformName);

    const download = useCallback((name) => {
        const information = DOWNLOAD_INFORMATION[name];
        if (!information?.url) return;

        if (name === 'ios' || name === 'android') {
            window.open(information.url, '_blank');
            return;
        }

        setDownloadError(false);
        setActivePlatform(name);

        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.onload = () => {
            setDownloadError(true);
        };
        iframe.src = information.url;
        document.body.appendChild(iframe);
        setTimeout(() => { try { document.body.removeChild(iframe); } catch (e) { /* already removed */ } }, 60000);
        trackAppDownload();
    }, [trackAppDownload]);

    useEffect(() => {
        const timer = setTimeout(() => {
            download(platformName);
        }, 500);

        return () => clearTimeout(timer);
    }, [platformName, download]);

    return (
        <PageBackground
            title="DOWNLOADS SOPO FOR DESKTOP"
            download
        >
            <div className='subtitle'>Play SOPO on your computer with faster performance and full-screen gameplay.</div>
            <div className='information-top-container'>
                <div className={downloadError ? "download-btn-error" : "download-btn"}>
                    {downloadError ? 'DOWNLOAD UNAVAILABLE' : `DOWNLOADING FOR ${DOWNLOAD_INFORMATION[activePlatform]?.name}...`}
                </div>
                <p className='download-description'>
                    {downloadError
                        ? <>Please try again later or <span className='click-here' onClick={() => download(activePlatform)}>retry</span>.</>
                        : <>Your download should start automatically. If it doesn't, <span className='click-here' onClick={() => download(activePlatform)}>click here</span>.</>
                    }
                </p>
                <p className='other-platform'>Other platforms:</p>
                <div className="device-buttons-container">
                    <div className="device-btn device-desktop" onClick={() => download("mac")}>macOS</div>
                    <div className="device-btn device-desktop" onClick={() => download("windows")}>Windows</div>
                    <div className="device-btn device-mobile" onClick={() => download("ios")}>iOS</div>
                    <div className="device-btn device-mobile" onClick={() => download("android")}>Android</div>
                </div>
            </div>
            <div className='information-bottom-container'>
                <p className='boxes-subtitle'>Get Started in 3 Steps</p>
                <div className='boxes-container'>
                    {downloadInformations.map((downloadInformation, index) => {
                        return (
                            <InformationBox key={index} number={index} title={downloadInformation.title} texts={downloadInformation.texts} background={downloadInformation.background} />
                        )
                    })}
                </div>
            </div>
        </PageBackground>
    );
};

export default DownloadInformation;
